// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from 'antd';
import 'antd/dist/antd.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import ErrorBoundary from 'components/primitive/ErrorBoundary';

import i18n from './i18n';
import AppRouter from './router';
import theme from 'styles/theme';
import GlobalStyle from 'styles/global';

function App() {
  useEffect(() => {
    // Source: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    function updateVh() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    updateVh();
    window.addEventListener('resize', updateVh);

    return window.removeEventListener('resize', updateVh);
  });

  return (
    <ConfigProvider autoInsertSpaceInButton={false}>
      <ThemeProvider theme={theme}>
        <I18nextProvider i18n={i18n}>
          <ErrorBoundary>
            <GlobalStyle />
            <AppRouter />
          </ErrorBoundary>
        </I18nextProvider>
      </ThemeProvider>
    </ConfigProvider>
  );
}

export default App;
